module.exports = __webpack_public_path__ + "static/12-4fae4eaa14b6c25b31dffa928572062a.jpg";